import { useState } from "react";
import style from "../css/AdminLogin.module.css";
import { useNavigate } from "react-router-dom";

function AdminLogin() {
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [showOtpField, setShowOtpField] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const navigate = useNavigate();

  const handleSendOtp = (e) => {
    e.preventDefault();

    if (phone.length !== 10) {
      setError("Please enter a valid 10 digit phone number");
      return;
    }

    setError("");
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
      setShowOtpField(true);
    }, 800);
  };

  const handleVerifyOtp = (e) => {
    e.preventDefault();

    if (otp === "1212") {
      localStorage.setItem(
        "adminAuth",
        JSON.stringify({
          phone,
          otp,
        }),
      );

      const timer = setTimeout(() => {
        navigate("/admin/dashboard");
      }, 2000);

      return () => clearTimeout(timer);

      // Add navigation here if needed
    } else {
      setError("Invalid OTP. Use 1212 to login.");
    }
  };

  return (
    <div className={style.loginWrapper}>
      <div className={style.loginCard}>
        <div className={style.logoSection}>
          <div className={style.logoCircle}>PD</div>
          <h2 className={style.heading}>Admin Login</h2>
          <p className={style.subText}>Secure access to admin dashboard</p>
        </div>

        {!success ? (
          <>
            <form
              onSubmit={showOtpField ? handleVerifyOtp : handleSendOtp}
              className={style.form}
            >
              <div className={style.inputGroup}>
                <label className={style.label}>Phone Number</label>
                <input
                  type="tel"
                  value={phone}
                  maxLength={10}
                  onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
                  placeholder="Enter phone number"
                  className={style.input}
                  disabled={showOtpField}
                />
              </div>

              {showOtpField && (
                <div className={style.inputGroup}>
                  <label className={style.label}>Enter OTP</label>
                  <input
                    type="password"
                    value={otp}
                    maxLength={4}
                    onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
                    placeholder="Enter OTP"
                    className={style.input}
                  />
                </div>
              )}

              {error && <p className={style.error}>{error}</p>}

              <button type="submit" className={style.loginBtn}>
                {loading
                  ? "Sending OTP..."
                  : showOtpField
                    ? "Verify OTP"
                    : "Send OTP"}
              </button>
            </form>
          </>
        ) : (
          <div className={style.successBox}>
            <div className={style.successIcon}>✓</div>
            <h3>Login Successful</h3>
            <p>Welcome Admin</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminLogin;
